import { IKeHoachNhomLopSelectRequest } from "../../model/request/ke-hoach/IKeHoachNhomLopSelectRequest";
import { IKeHoachNhomLopSysRequest } from "../../model/request/ke-hoach/IKeHoachNhomLopSysRequest";
import { IKeHoachNhomLopTachLopRequest } from "../../model/request/ke-hoach/IKeHoachNhomLopTachLopRequest";
import { IKeHoachNhomLop } from "../../model/respone/ke-hoach/IKeHoachNhomLop";
import { IIdsRequest } from "../../model/request/IIdsRequest";
import { apiClient } from "../apiClient";
import { lopTinChiApi } from "../lop-tin-chi/lopTinChiApi";
export const KE_HOACH_NHOM_LOP_ENDPOINT = "ke-hoach-nhom-lop";
export const keHoachNhomLopApi = {
     Select: (request: IKeHoachNhomLopSelectRequest) => apiClient.post(`${KE_HOACH_NHOM_LOP_ENDPOINT}/select`, request),
     SelectWarnings: (request: IKeHoachNhomLopSelectRequest) => apiClient.post(`${KE_HOACH_NHOM_LOP_ENDPOINT}/warnings`, request),
     SysFromKeHoachMon: (request: IKeHoachNhomLopSysRequest) => apiClient.post(`${KE_HOACH_NHOM_LOP_ENDPOINT}/sys-from-ke-hoach-mon`, request),
     Update: (request: IKeHoachNhomLop) => apiClient.put(`${KE_HOACH_NHOM_LOP_ENDPOINT}`, request),
     TachLops: (request: IKeHoachNhomLopTachLopRequest) => apiClient.post(`${KE_HOACH_NHOM_LOP_ENDPOINT}/tach-lops`, request),
     Deletes: (request: IIdsRequest) => apiClient.put(`${KE_HOACH_NHOM_LOP_ENDPOINT}/deletes`, request),
     SelectDongBo: (request: { hoc_ky: number; nam_hoc: string; id_he: number }) =>
          apiClient.post(`${KE_HOACH_NHOM_LOP_ENDPOINT}/select-dong-bo-giai-doan`, request),
     DongBoGiaiDoan: (request: { hoc_ky: number; nam_hoc: string; id_he: number; ids: number[] }) =>
          apiClient.post(`${KE_HOACH_NHOM_LOP_ENDPOINT}/dong-bo-giai-doan-theo-ke-hoach`, request),
}

// Ngưỡng sĩ số tách lớp: tổng so_sv_max các lớp con >= ngưỡng -> môn được tách do lớp to,
// hạ sĩ số nhóm xuống dưới ngưỡng thì mặc định gộp lại (tick sẵn trong modal chọn gộp).
export const NGUONG_SI_SO_LOP_TACH = 61;

// 1 môn trong nhóm đang bị tách lớp -> ứng viên để gộp về 1 khi hạ sĩ số.
export interface IMonTachDeGop {
     keHoachId: number;       // id ke-hoach-nhom-lop để gọi gộp (so_lop_tach = 0)
     id_mon: number;
     ten_mon: string;
     ten_nhom: string;
     soLop: number;           // số lớp tín chỉ hiện có của môn
     tongSoSvMax: number;     // tổng so_sv_max các lớp con
     defaultChecked: boolean; // tick mặc định khi tongSoSvMax >= NGUONG_SI_SO_LOP_TACH
}

// Lấy danh sách môn đang bị tách lớp trong 1 nhóm, kèm tổng so_sv_max để quyết định tick mặc định.
export async function getMonTachDeGop(params: {
     hoc_ky: number;
     nam_hoc: string;
     id_he: number;
     khoa_hoc: number;
     id_chuyen_nganh: number;
     stu_nhomlop_id: number;
}): Promise<IMonTachDeGop[]> {
     const [khRes, lopRes] = await Promise.all([
          keHoachNhomLopApi.Select({
               hoc_ky: params.hoc_ky,
               nam_hoc: params.nam_hoc,
               id_he: params.id_he,
               stu_nhomlop_id: params.stu_nhomlop_id,
          }),
          lopTinChiApi.Select({
               ky_dang_ky: 0,
               nam_hoc: params.nam_hoc,
               hoc_ky: params.hoc_ky,
               id_he: params.id_he,
               khoa_hoc: params.khoa_hoc,
               id_chuyen_nganh: params.id_chuyen_nganh,
               stu_nhomlop_id: params.stu_nhomlop_id,
          }),
     ]);

     const khList = (khRes.is_success && Array.isArray(khRes.data) ? khRes.data : [])
          .filter((k: any) => (k.so_lop_tach ?? 0) > 0);
     const lops = lopRes.is_success && Array.isArray(lopRes.data) ? lopRes.data : [];

     return khList.map((k: any) => {
          const lopsCuaMon = lops.filter(
               (l: any) => l.id_mon === k.id_mon && l.stu_nhomlop_ids === k.stu_nhomlop_id
          );
          const tongSoSvMax = lopsCuaMon.reduce((s: number, l: any) => s + (l.so_sv_max ?? 0), 0);
          return {
               keHoachId: k.id,
               id_mon: k.id_mon,
               ten_mon: k.ten_mon ?? "",
               ten_nhom: k.ten_nhom ?? "",
               soLop: lopsCuaMon.length,
               tongSoSvMax,
               defaultChecked: tongSoSvMax >= NGUONG_SI_SO_LOP_TACH,
          } as IMonTachDeGop;
     });
}

// Gộp các môn về 1 lớp: set so_lop_tach = 0 -> backend XuLyTachGopLop tự gộp & xoá lớp tách dư.
export const gopLopVe1 = (ids: number[]) => keHoachNhomLopApi.TachLops({ ids, so_lop_tach: 0 });